import { requestJson } from '@vfde-sails/utils';
import { getLandUsePostJson, preparePostData } from 'Container/glasfaserRegistration/helpers/sagaHelper';
import {
    ADDITIONAL_CMS_SITE_STRUCTURE,
    JSON_HEADER,
    TRACKING_NOT_LOGGED_IN,
} from '../../constant';
import {
    getRegistrationSuccess,
    handleInvalidApiResponse,
    trackInitialPageView,
    trackRegistrationSuccess,
} from './action';
import {
    FormType,
    GLASFASER_LANDUSE_REGISTRATION_API_URL, GLASFASER_REGISTRATION_API_URL,
    INIT_REGISTRATION_FORM, SEND_REGISTRATION_DATA,
} from './constant';
import { getFormType } from './helpers/formHelper';
import { selectRegistrationData } from './selector';

import * as Effects from 'redux-saga/effects';

// This is a fix for the below error, emerged using call effect:
// https://stackoverflow.com/questions/62359938/no-overload-matches-this-call-in-saga-call-effect
const call: any = Effects.call;
const put: any = Effects.put;
const select: any = Effects.select;
const takeLatest: any = Effects.takeLatest;

/**
 * getApiData
 */
export function* sendRegistrationData () {

    const loginStatus = TRACKING_NOT_LOGGED_IN;
    const siteStructure =  ADDITIONAL_CMS_SITE_STRUCTURE;
    const formType = getFormType();

    const formData = yield select(selectRegistrationData());

    let data: FormData | Object;
    let apiUrl: string;
    let headers: HeadersInit;

    switch (formType) {
        case FormType.REGISTRATION:
            data = preparePostData(formData);
            apiUrl = GLASFASER_REGISTRATION_API_URL;
            break;
        case FormType.LANDUSE:
            headers = JSON_HEADER;
            data = JSON.stringify(getLandUsePostJson(formData));
            apiUrl = GLASFASER_LANDUSE_REGISTRATION_API_URL;
            break;
    }

    const options = {
        method: 'POST',
        headers,
        body: data,
    };
    try {
        const response = yield call(requestJson, apiUrl, options);
        const result = response.body.result;
        if ('ok' === result) {
            yield put(getRegistrationSuccess(result));
            yield put(trackRegistrationSuccess(siteStructure, loginStatus));
        } else {
            yield put(handleInvalidApiResponse());
        }
    } catch (e) {
        yield put(handleInvalidApiResponse());
    }
}

/**
 * initTracking
 */
export function* initTracking () {
    const loginStatus = TRACKING_NOT_LOGGED_IN;
    const siteStructure = ADDITIONAL_CMS_SITE_STRUCTURE;

    yield put(trackInitialPageView(siteStructure, loginStatus));
}

/**
 * export form data saga
 */
export default function* glasfaserRegistrationSaga () {
    yield takeLatest(SEND_REGISTRATION_DATA, sendRegistrationData);
    yield takeLatest(INIT_REGISTRATION_FORM, initTracking);
}
